import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { CoreService } from '@portal-client/core/core.service';
import { AuthService } from '@portal-core/auth/services/auth.service';
import { LicenseUserSeatType } from '@portal-core/license-users/enums/license-user-seat-type.enum';
import { first, map, of } from 'rxjs';

export const licenseDefaultPageResolver: ResolveFn<string> = () => {
  const coreService = inject(CoreService);
  const router = inject(Router);
  const authService = inject(AuthService);

  if (!authService.isAuthenticated()) {
    return of(null);
  }

  return coreService.getLicenseUser$().pipe(
    first(licenseUser => !!licenseUser),
    map(licenseUser => {
      let routePath: string;

      switch (licenseUser.SeatType) {
        case LicenseUserSeatType.SME:
          routePath = 'reviews';
          break;
        case LicenseUserSeatType.Author:
        default:
          routePath = 'home';
          break;
      }

      router.navigate([licenseUser.LicenseId, routePath]);
      return routePath;
    })
  );
};
